import { gosafeApi } from "../../api";

const fileCleanupMiddleware = (store) => (next) => async (action) => {
  const result = next(action);

  if (
    action.type === "quiz/goBackToStart" ||
    action.type === "quiz/resetQuiz" ||
    action.type === "quiz/setQuizMode"
  ) {
    // console.log("Cleaning up files for action:", action.type);
    const state = store.getState();
    const uploadingFiles = state.patient.quiz.uploadingFiles;

    const uploadedUrls = Object.values(uploadingFiles)
      .flatMap((file) => file.files || [])
      .map((file) => file.url)
      .filter(Boolean);

    if (uploadedUrls.length > 0) {
      try {
        await gosafeApi.delete("/fileUploader", {
          data: { urls: uploadedUrls },
        });
        // console.log('Files deleted successfully');

        // Clear uploadingFiles from state
        Object.keys(uploadingFiles).forEach((questionId) => {
          store.dispatch({
            type: "quiz/removeUploadedFile",
            payload: { questionId },
          });
        });
      } catch (error) {
        console.error("Error deleting files:", error);
      }
    }
  }

  return result;
};

export default fileCleanupMiddleware;
